import { FC, useState } from 'react'

import TeamsRequestAccessBanner from '~/components/TeamsRequestAccessBanner'
import VerifyEmailAddressAlert from '../VerifyEmailAddressAlert'

interface BannerBundlePropsType {
    placement: string // for link tracking in banners with links
}

export const BannerBundle: FC<BannerBundlePropsType> = ({ placement }) => {
    const [hideVerifyBanner, setHideVerifyBanner] = useState<boolean>(false)

    return (
        <>
            {!hideVerifyBanner && (
                <VerifyEmailAddressAlert placement={placement} />
            )}
            <TeamsRequestAccessBanner
                onShowingVerifyBanner={isShowing => {
                    setHideVerifyBanner(isShowing)
                }}
            />
        </>
    )
}

export default BannerBundle
